module.exports = __webpack_public_path__ + "static/media/line.a531e603.svg";